export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale/src/number.js
// module id = 231
// module chunks = 0